// Smooth scroll for in-page CTAs on the mozi-wash landing sections: any
// [data-mw-scroll] link whose href is #id glides to that element.
(function () {
  if (window.mwScrollBound) return;
  window.mwScrollBound = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-mw-scroll]');
    if (!link) return;
    var hash = link.getAttribute('href') || '';
    if (hash.charAt(0) !== '#' || hash.length < 2) return;
    var target = document.getElementById(hash.slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
